import React, { useState, useEffect } from "react";
import "./style.css";
import { Table, Typography, Button, Tooltip } from "antd";
import { getWalletIssueList } from "../../services/walletIssue.service";
import Pageloader from "../../components/loader";
import { validationErrors } from "../../utils/Helpers";
import { CheckCircleOutlined } from "@ant-design/icons";
import ModalIssueApprove from "../../components/modal/walletIssue/modalIssueApprove";
import moment from "moment";
import * as walletIssueActions from "../../redux/actions/walletIssue.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Text, Title } = Typography;

const WalletIssues = (props) => {
  const pagename = "Wallet Issues";
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [MBtnLoading, setMBtnLoading] = useState(false);

  useEffect(() => {
    postLists();
  }, []);

  useEffect(() => {
    setPostData(props.walletIssueData);
  }, [props.walletIssueData]);

  const postLists = async () => {
    setLoading(true);
    postListsrefresh();
  };
  const postListsrefresh = async () => {
    try {
      setMBtnLoading(true);
      const datapost = {
        page: 1,
        limit: 2,
      };
      // const resp = await getWalletIssueList(datapost);
      await props.walletIssueActions.getWalletIssueListAction(datapost);
      // setPostData(resp.data.data);
    } catch (e) {
      validationErrors(e);
    } finally {
      setMBtnLoading(false);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Date",
      render: (proId) => {
        const STview = moment(proId.created_at).format("DD/MM/yyyy");
        return STview;
      },
    },
    {
      title: "Name",
      render: (proId) =>
        proId ? <Text>{proId.task.rider.fullName}</Text> : "-",
    },
    {
      title: "Order ",
      render: (task) => (task ? <Text>{task.order_id}</Text> : "-"),
      dataIndex: "task",
    },
    {
      title: "Type",
      render: (type) => (type ? <Text>{type}</Text> : "-"),
      dataIndex: "type",
    },
    // {
    //   title: "Platform",
    //   render: (prodid) =>
    //     prodid.task.store.name != "" ? (
    //       <Text>{prodid.task.store.name}</Text>
    //     ) : (
    //       "-"
    //     ),
    // },
    {
      title: "Original",
      render: (proId) =>
        proId ? (
          <Text type="success">{proId.task.order_details.total_amount}</Text>
        ) : (
          "-"
        ),
    },
    {
      title: "Actual",
      render: (amount) => (amount ? <Text type="success">{amount}</Text> : "-"),
      dataIndex: "amount",
    },
    {
      title: "Discrepancy",
      render: (amount) => (amount ? <Text type="danger">{amount}</Text> : "-"),
      dataIndex: "amount",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Action",
      render: (proid) => {
        return proid.approved === true ? (
          <Text type="success">Resolved</Text>
        ) : proid.approved === false || proid.updatedBy != null ? (
          <Text type="danger">Rejected</Text>
        ) : (
          <Tooltip title="Approve Issue">
            <Button
              onClick={() => showIssueApprove(proid)}
              disabled={MBtnLoading}
            >
              <CheckCircleOutlined />
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  const [showModalApproveIssue, setshowModalApproveIssue] = useState(false);
  const [showModalApproveIssueID, setshowModalApproveIssueID] = useState(null);
  const showIssueApprove = (value) => {
    setshowModalApproveIssueID(value);
    setshowModalApproveIssue(true);
  };

  return (
    <div className="page-content">
      <ModalIssueApprove
        visible={showModalApproveIssue}
        setvisible={setshowModalApproveIssue}
        issueData={showModalApproveIssueID}
        postListsrefresh={postListsrefresh}
      />
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}</Title>
        </div>
        <div className="pch"></div>
      </div>
      <div className="p-content">
        {loading ? (
          <Pageloader />
        ) : (
          <Table columns={columns} dataSource={postData} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    walletIssueData: state.WalletIssueReducer.walletIssueData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    walletIssueActions: bindActionCreators(walletIssueActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletIssues);
